<table [ngClass]="!customCssClass ? 'table table-hover' : customCssClass">
  <ng-content select="[header]"></ng-content>
  <ng-content select="[body]"></ng-content>
</table>
